var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgVisa(props) {
    return (React.createElement("svg", __assign({ width: "37", height: "25", viewBox: "0 0 37 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { clipPath: "url(#clip0)" },
            React.createElement("path", { fill: "#1434cb", d: "M11.86,10.94l-3.42,8.15h-2.23l-1.68-6.5c-.1-.4-.19-.55-.5-.72-.51-.27-1.34-.53-2.08-.69l.05-.24h3.59c.46,0,.87,.3,.97,.83l.89,4.71,2.19-5.55h2.21Zm8.73,5.49c0-2.15-2.97-2.27-2.95-3.23,0-.29,.28-.6,.89-.68,.3-.04,1.13-.07,2.08,.36l.37-1.73c-.51-.18-1.16-.36-1.97-.36-2.08,0-3.55,1.11-3.56,2.69-.01,1.17,1.05,1.83,1.85,2.22,.82,.4,1.1,.66,1.09,1.01,0,.55-.66,.79-1.26,.8-1.06,.02-1.67-.29-2.16-.51l-.38,1.79c.49,.23,1.4,.42,2.34,.43,2.21,0,3.66-1.09,3.67-2.79m5.5,2.66h1.95l-1.7-8.15h-1.8c-.4,0-.75,.24-.9,.6l-3.16,7.55h2.21l.44-1.22h2.7l.25,1.22Zm-2.35-2.89l1.11-3.06,.64,3.06h-1.75Zm-8.87-5.26l-1.74,8.15h-2.11l1.74-8.15h2.11Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0" },
                React.createElement("path", { fill: "#fff", transform: "translate(.128)", d: "M0 0h36.184v25H0z" })))));
}
export default SvgVisa;
